export default __webpack_public_path__ + "static/media/driver-icon-white.eabc958f.svg";